import { render, staticRenderFns } from "./FormRFQ.vue?vue&type=template&id=39e64f2c&"
import script from "./FormRFQ.vue?vue&type=script&lang=js&"
export * from "./FormRFQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports